<template>
    <div>
        <h1>{{ $t('demo.header') }}</h1>
        <div v-show="!error" class="ct-card">
            <section>
                <h3>{{ $t('demo.information.header') }}</h3>
                <p class="text-center">{{ $t('demo.information.text') }}</p>
                <p class="text-center" v-html="$t('demo.support.text')"></p>
            </section>

            <section v-if="showCreateButton()" class="ct-action">
                <div>
                    <select-input
                        :config="{
                            translationKey: 'demo.template.label',
                            required: true,
                            id: 'template-select',
                            prefix: 'demo.template'
                        }"
                        preSelect="freikirche"
                        :options="options.templates"
                        :input-model.sync="template"
                    ></select-input>
                </div>
                <div class="ct-input-element">
                    <button
                        v-on:click="createDemo()"
                        :disabled="template === null"
                        type="button"
                        id="demo-create-btn"
                        class="btn btn-primary btn-lg btn-block"
                    >
                        {{ $t('demo.create.button') }}
                    </button>
                </div>
            </section>

            <section v-else-if="showChurchToolsButton()" class="ct-action">
                <div class="ct-input-element">
                    <a
                        v-if="url && !isLoading"
                        id="demo-link"
                        class="btn btn-primary btn-lg btn-block"
                        :href="url"
                        target="_blank"
                        >{{ $t('demo.churchtools.button') }}</a
                    >
                </div>
                <div class="ct-input-element">
                    <div class="ct-hint">
                        {{ $t('demo.churchtools.text') }}:<br />
                        <a :href="url">{{ url }}</a>
                    </div>
                </div>
            </section>

            <section v-else class="ct-action">
                <Spinner></Spinner>
                <div class="ct-input-element">
                    <div class="ct-hint">{{ $t('demo.create.spinner') }}</div>
                </div>
            </section>
        </div>

        <div v-show="error" class="ct-card">
            <section>
                <h3>{{ $t('demo.error.header') }}</h3>
                <p class="text-center">{{ $t('demo.error.text') }}</p>
            </section>

            <section class="ct-action">
                <div class="ct-input-element">
                    <button v-on:click="reload()" type="button" class="btn btn-primary btn-lg btn-block">
                        {{ $t('demo.error.reload') }}
                    </button>
                </div>

                <div class="ct-input-element">
                    <a href="https://contact.church.tools" class="btn btn-secondary btn-lg btn-block">
                        {{ $t('demo.support.contact') }}
                    </a>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Spinner from '../components/Spinner.vue';
import axios from 'axios';
import SelectInput from '../components/inputs/SelectInput.vue';

export default {
    name: 'Demo',
    components: { SelectInput, Spinner },

    data() {
        return {
            demoCreated: false,
            url: null,
            sitename: null,
            isLoading: false,
            error: false,
            template: null,
            options: {
                templates: ['freikirche', 'evangelisch', 'katholisch', 'cvjm']
            }
        };
    },

    mounted() {
        document.title = 'ChurchTools Demo';
    },

    methods: {
        createDemo() {
            this.isLoading = true;
            axios
                .post(`/api/demo?template=${this.template}`)
                .then(result => {
                    this.url = result.data.url;
                    this.sitename = result.data.sitename;
                    this.checkDemoIsCreated();
                })
                .catch(err => {
                    this.isLoading = false;
                    this.error = true;
                    console.error(err);
                });
        },
        checkDemoIsCreated() {
            axios
                .get(`/api/demo/check/${this.sitename}?template=${this.template}`)
                .then(() => {
                    this.isLoading = false;
                    this.demoCreated = true;
                })
                .catch(() => {
                    window.setTimeout(() => {
                        this.checkDemoIsCreated();
                    }, 5000);
                });
        },
        showCreateButton() {
            return this.demoCreated === false && !this.isLoading && !this.error;
        },
        showChurchToolsButton() {
            return this.demoCreated && !this.isLoading && !this.error;
        },
        reload() {
            window.location.reload();
        }
    }
};
</script>
